<finder-component-header [data]="headerData"></finder-component-header>
<div class="map-container">
    <div class="list" *ngIf="showList">
        <finder-accordion [data]="accordionData" (clickedElement)="updateMap($event)" [openCategory]="openCategory"></finder-accordion>
    </div>
    <div class="map keep-zoom-controls" [ngClass]="{'full-width': !showList}">
        <ng-template #finderMap></ng-template>
    </div>
</div>
